import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b8648f04")

_pushScopeId("data-v-b8648f04")
const _hoisted_1 = { class: "ques" }
const _hoisted_2 = { class: "q-cont" }
const _hoisted_3 = { class: "q-a-area" }
const _hoisted_4 = {
  key: 0,
  class: "answer-area"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("dt", null, "答案：", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("dt", null, "得分：", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("dt", null, "解析：", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("p", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.quesData.totalSort ? _ctx.quesData.totalSort + '.' : ''), 1),
      _createVNode("span", {
        innerHTML: _ctx.quesData.questionContent
      }, null, 8, ["innerHTML"]),
      _createTextVNode(_toDisplayString(_ctx.quesData.score ? '（' + _ctx.quesData.score + '分）' : ''), 1)
    ]),
    _createVNode("div", _hoisted_3, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.quesData.blank, (index) => {
        return (_openBlock(), _createBlock(_component_el_input, {
          key: index,
          placeholder: !_ctx.showAnswer ? '请在这里输入答案' : '',
          modelValue: _ctx.completionList[index - 1],
          "onUpdate:modelValue": ($event: any) => (_ctx.completionList[index - 1] = $event),
          onInput: _ctx.handleContentInput,
          readonly: _ctx.showAnswer
        }, {
          prepend: _withId(() => [
            _createVNode("span", null, _toDisplayString(index), 1)
          ]),
          _: 2
        }, 1032, ["placeholder", "modelValue", "onUpdate:modelValue", "onInput", "readonly"]))
      }), 128))
    ]),
    (_ctx.showAnswer)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode("dl", null, [
            _hoisted_5,
            _createVNode("dd", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.quesData.blank, (index) => {
                return (_openBlock(), _createBlock("p", { key: index }, _toDisplayString(index) + "." + _toDisplayString(_ctx.rightAnswer[index - 1]), 1))
              }), 128))
            ])
          ]),
          _createVNode("dl", null, [
            _hoisted_6,
            _createVNode("dd", null, _toDisplayString(_ctx.quesData.studentScore), 1)
          ]),
          _createVNode("dl", null, [
            _hoisted_7,
            _createVNode("dd", null, _toDisplayString(_ctx.quesData.analysis ? _ctx.quesData.analysis : '略'), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})